import ApiClientFactory from '../../../api/client-factory';
import { OrderNotificationsApiService } from './service';

const service = new OrderNotificationsApiService(ApiClientFactory());

export function OrderNotificationsApiServiceFactory(): typeof service {
  return service;
}
